import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Optimistic star/favorite toggle for neighbors.
// Swaps the icon immediately on click, then fires a PATCH in the background.
// The server responds with a Turbo Stream to update the starred neighbors list.
export default class extends Controller {
  static targets = ["icon"];
  static values = {
    url: String,
    starred: Boolean,
  };

  declare iconTarget: HTMLElement;
  declare urlValue: string;
  declare starredValue: boolean;

  toggle(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    // Optimistic: flip state and icon immediately
    this.starredValue = !this.starredValue;
    this.updateIcon();

    // Fire request in background
    /* eslint-disable i18next/no-literal-string */
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");
    /* eslint-enable i18next/no-literal-string */

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken || "",
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then(async (response) => {
        if (response.ok) {
          const html = await response.text();
          Turbo.renderStreamMessage(html);
        }
      })
      .catch(() => {
        // Revert on failure
        this.starredValue = !this.starredValue;
        this.updateIcon();
      });
  }

  private updateIcon() {
    if (this.starredValue) {
      this.iconTarget.innerHTML = this.starSvg();
      this.element.classList.remove(
        "opacity-50",
        "hover:opacity-100",
      );
    } else {
      this.iconTarget.innerHTML = this.starOutlineSvg();
      this.element.classList.add("opacity-50", "hover:opacity-100");
    }
  }

  private starSvg(): string {
    /* eslint-disable i18next/no-literal-string */
    return `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class='h-5 w-5' viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`;
    /* eslint-enable i18next/no-literal-string */
  }

  private starOutlineSvg(): string {
    /* eslint-disable i18next/no-literal-string */
    return `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class='h-5 w-5' viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`;
    /* eslint-enable i18next/no-literal-string */
  }
}
